const chatContexts = {
  '/langchain/chat/': '学习助手对话',
  '/assessment/question/chat/': '题目复盘对话',
  '/experiment/chat/': '实验助手对话',
};

const questionTypeLabels = {
  SC: '单选题',
  MC: '多选题',
  SA: '主观题',
};

function text(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function formatAnswer(value) {
  if (Array.isArray(value))
    return value.map(String).join('、');
  return value === null || value === undefined ? '' : String(value);
}

function assessmentResult(payload) {
  if (payload?.judge_status === 'pending')
    return { label: '等待判分', tone: 'pending' };
  if (payload?.is_correct === true)
    return { label: '回答正确', tone: 'success' };
  if (payload?.judge_status === 'completed')
    return { label: '需要复习', tone: 'danger' };
  return { label: '已提交', tone: 'neutral' };
}

export function presentMemoryEvent(event) {
  if (event.event_type === 'chat_message') {
    return {
      kind: 'chat',
      context: chatContexts[event.path] ?? 'AI 对话',
      question: text(event.request_payload?.message),
      answer: text(event.response_payload?.reply),
    };
  }

  return {
    kind: 'assessment',
    question: text(event.request_payload?.question),
    answer: formatAnswer(event.request_payload?.answer),
    questionType: questionTypeLabels[event.request_payload?.question_type] ?? '练习题',
    result: assessmentResult(event.response_payload),
  };
}
